import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Score } from "../../../components/Score";
import { ScoreBarChart } from "../../../components/ScoreBarChart";




export default function CreditoScore({
  creditoScore,
  informativo
}: {
  creditoScore: any;
  informativo?: any;
}) {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";




  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if (creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.forEach((prot: any) => {
        quantidade++;
        valorTotal = valorTotal + Number(prot.VALOR.replace('.', '').replace(',', '.'))
        if (!comarcas.includes(prot.COMARCA)) {
          comarcas.push(prot.COMARCA)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }

  const numberFormat = (value: number, width: number) => {
    return new Array(width + 1 - (value + '').length).join('0') + value;
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }


  const headerTemplatePendencia = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PEND_FINANCEIRAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia')}</span>)}</div>;
  }

  const headerTemplatePassagens = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PASSAGENS_COMERCIAIS && creditoScore.PASSAGENS_COMERCIAIS.OCORRENCIAS && creditoScore.PASSAGENS_COMERCIAIS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Passagens Comerciais</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Passagens Comerciais</span>)}</div>;
  }

  const headerTemplateScores = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.SCORES && creditoScore.SCORES.OCORRENCIAS && creditoScore.SCORES.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('score')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('score teste')}</span>)}</div>;
  }

  const headerTemplateAdministradores = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.ADMINISTRADORES_DA_EMPRESA && creditoScore.ADMINISTRADORES_DA_EMPRESA.ADMINISTRADORES && creditoScore.ADMINISTRADORES_DA_EMPRESA.ADMINISTRADORES.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Administradores</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Administradores</span>)}</div>;
  }

  const headerTemplateProtestosNew = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PROTESTOS && creditoScore.PROTESTOS.OCORRENCIAS && creditoScore.PROTESTOS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }

  const headerTemplateReceita = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.DADOS_RECEITA_FEDERAL ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('receitaFederal')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('receitaFederal')}</span>)}</div>;
  }

  const headerTemplatePendRefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PEND_REFIN && creditoScore.PEND_REFIN.OCORRENCIAS && creditoScore.PEND_REFIN.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('refins')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('refins')}</span>)}</div>;
  }

  const headerTemplatePendVencidas = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PEND_VENCIDAS && creditoScore.PEND_VENCIDAS.OCORRENCIAS && creditoScore.PEND_VENCIDAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Pendências Vencidas</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Pendências Vencidas</span>)}</div>;
  }

  const headerTemplateCheques = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.CH_SEM_FUNDOS_BACEN && creditoScore.CH_SEM_FUNDOS_BACEN.OCORRENCIAS && creditoScore.CH_SEM_FUNDOS_BACEN.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Cheques Sem Fundos teste</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Cheques Sem Fundos</span>)}</div>;
  };

  const headerTemplateParticipacaoEmpresas = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PARTICIPACAO_EMPRESAS && creditoScore.PARTICIPACAO_EMPRESAS.OCORRENCIAS && creditoScore.PARTICIPACAO_EMPRESAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Participação em Empresas</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>Participação em Empresas</span>)}</div>;
  };

  return (
    <div>
      {creditoScore.mensagemErro ? (<p>{creditoScore.mensagemErro}</p>) :
        (<div>
          {creditoScore.DADOS_RECEITA_FEDERAL && (
            <>
              <Panel headerTemplate={headerTemplateReceita}>
                <div className="grid">
                  <div className="col-12 md:col-6 flex flex-column gap-6">
                    <div className="flex gap-2 mb-2">
                      <strong>CNPJ:</strong> <span>{formatarCNPJ(creditoScore.DADOS_RECEITA_FEDERAL.CNPJ ?? creditoScore.CH_SEM_FUNDOS_BACEN?.CPFCNPJ ?? '')}</span>
                    </div>
                    <div className="flex gap-2 mb-2">
                      <strong>Nome Fantasia:</strong> <span>{getValue(creditoScore.DADOS_RECEITA_FEDERAL.NOME_FANTASIA || creditoScore.DADOS_RECEITA_FEDERAL.NOME)}</span>
                    </div>
                    <div className="flex gap-2 mb-2">
                      <strong>Razão Social:</strong> <span>{getValue(creditoScore.DADOS_RECEITA_FEDERAL.RAZAO_SOCIAL)}</span>
                    </div>
                  </div>
                  <div className="col-12 md:col-6 flex flex-column gap-6">
                    <div className="flex gap-2 mb-2">
                      <strong>Fundação:</strong> <span>{getValue(creditoScore.DADOS_RECEITA_FEDERAL.DATA_NASCIMENTO_FUNDACAO)}</span>
                    </div>
                    <div className="flex gap-2 mb-2">
                      <strong>Situação:</strong> <span>{getValue(creditoScore.DADOS_RECEITA_FEDERAL.SITUACAO_RECEITA)}</span>
                    </div>
                  </div>
                </div>
              </Panel>
              <br></br>
            </>
          )}

          {/* Codigo foi comentando para atender a solicitacao da tarefa https://redmine-redmine.jistk6.easypanel.host/issues/511 */}
          {/* {creditoScore.SCORES && (
            <>
              <Panel headerTemplate={headerTemplateScores}>
                {!creditoScore.SCORES.OCORRENCIAS || creditoScore.SCORES.OCORRENCIAS.length === 0 ? (
                  <NadaConsta />
                ) : (
                  <>
                    {creditoScore.SCORES.OCORRENCIAS.map((item: any, index: number) => {
                      const scoreValue = Number(item.SCORE);
                      let color = '#ccc';
                      const getRange = (score: number) => {
                        if (score <= 300) return 'RUIM';
                        if (score <= 600) return 'REGULAR';
                        return 'OTIMO';
                      };
                      const range = getRange(scoreValue);
                      const topMarkers = ['0', '300', '600', '1000'];
                      const bottomLabels = ['Risco Alto', 'Risco Médio', 'Risco Baixo'];

                      return (
                        <div key={index} className="grid mb-5 border-bottom-1 surface-border pb-4">
                          <div className="col-12 grid" style={{ gap: "5rem" }}>
                            <div className="col flex flex-column align-items-center">
                              <div className="font-bold text-xl mb-2" style={{ color: '#003366' }}>{item.TIPO_SCORE}</div>
                              <h5>Pontuação</h5>
                              <Score score={item.SCORE} range={range} />
                            </div>
                            <div className="col flex flex-column align-items-center">
                              <div className="mb-3">

                                <h5>Faixa de Risco</h5>
                                <ScoreBarChart
                                  score={scoreValue}
                                  topMarkers={topMarkers}
                                  bottomLabels={bottomLabels}
                                  reverse={false}
                                  maxScore={1000}
                                />
                              </div>
                              <div className="mb-3 text-lg" style={{ color: '#C70039' }}>
                                PROBABILIDADE DE INADIMPLÊNCIA = {item.PROBABILIDADE_INADIMPLENCIA || 'N/A'}
                              </div>
                              <div className="mb-3 text-700">
                                {item.TEXTO}
                              </div>
                              <div className="text-sm text-600 font-italic">
                                <strong>IMPORTANTE: </strong> a decisão de aprovação ou não do crédito é de exclusiva responsabilidade do concedente.
                                As informações prestadas pelo provedor tem como objetivo subsidiar essas decisões e, em hipótese alguma devem ser utilizadas como justificativa, pelo concedente do crédito, para a tomada da referida decisão.
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </Panel>
              <br></br>
            </>
          )} */}

          {creditoScore.ADMINISTRADORES_DA_EMPRESA && (
            <Panel headerTemplate={headerTemplateAdministradores}>
              {!creditoScore.ADMINISTRADORES_DA_EMPRESA.ADMINISTRADORES || creditoScore.ADMINISTRADORES_DA_EMPRESA.ADMINISTRADORES.length === 0 ? (<NadaConsta />) : (
                <div className="flex flex-column gap-6 mb-4">
                  {creditoScore.ADMINISTRADORES_DA_EMPRESA.ADMINISTRADORES.map((admin: any, index: number) => (
                    <div key={index} className="border-1 surface-border border-round">
                      <div className="surface-100 p-2 font-bold text-blue-600 mb-3" style={{ backgroundColor: '#F0F8FF' }}>
                        {admin.NOME}
                      </div>
                      <div className="grid p-3">
                        <div className="col-12 md:col-6">
                          <div className="mb-2"><strong>CARGO:</strong> {getValue(admin.CARGO)}</div>
                        </div>
                        <div className="col-12 md:col-6">
                          <div className="mb-2"><strong>NOME:</strong> {admin.NOME}</div>
                          <div className="mb-2"><strong>CPF:</strong> {admin.CPF}</div>
                        </div>
                      </div>
                      <div className="p-3">
                        {admin.INDICADOR_DEBITO == 1 ? (
                          <div className="surface-100 p-3 border-round flex flex-column gap-2" style={{ backgroundColor: '#FEF2F2', color: '#B91C1C' }}>
                            <div className="font-bold">ALERTA: EXISTEM DÉBITOS/RESTRIÇÕES.</div>
                            <div className="font-bold">ALERTA: EXISTEM REGISTROS DE DÉBITOS/RESTRIÇÕES</div>
                          </div>
                        ) : (
                          <div className="surface-100 p-3 border-round flex align-items-center gap-2" style={{ backgroundColor: '#DCFCE7', color: '#166534' }}>
                            <i className="pi pi-check-circle text-green-700"></i>
                            <span className="font-bold">NENHUM REGISTRO DE DÉBITO ENCONTRADO. NADA CONSTA.</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Panel>
          )}
          <br></br>

          {creditoScore.PEND_FINANCEIRAS && <Panel headerTemplate={headerTemplatePendencia}>
            {!creditoScore.PEND_FINANCEIRAS || !creditoScore.PEND_FINANCEIRAS.OCORRENCIAS || creditoScore.PEND_FINANCEIRAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (
              (() => {
                const ocorrencias = creditoScore.PEND_FINANCEIRAS.OCORRENCIAS;
                const parseValor = (v: any) => {
                  if (typeof v === 'number') return v;
                  if (typeof v === 'string') {
                    // Remove R$, dots and replace comma with dot
                    const clean = v.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
                    return parseFloat(clean) || 0;
                  }
                  return 0;
                };
                // Sort by date descending to find latest maturity
                // Assuming DATA_VENCIMENTO is DD/MM/YYYY
                const sortedByDate = [...ocorrencias].sort((a: any, b: any) => {
                  const dateA = a.DATA_VENCIMENTO ? a.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                  const dateB = b.DATA_VENCIMENTO ? b.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                  return dateB.localeCompare(dateA);
                });
                const ultimoVencimento = sortedByDate[0]?.DATA_VENCIMENTO || '-';

                return (
                  <div className="flex flex-column gap-4">
                    {/* Resumo Section */}
                    <div className="surface-100 border-round">
                      <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">RESUMO</div>
                      <div className="grid p-3">
                        <div className="col-12 md:col-6">
                          <div className="mb-2"><strong className="mr-2">QUANTIDADE:</strong> {creditoScore.PEND_FINANCEIRAS.QUANTIDADE_OCORRENCIA}</div>
                          <div className="mb-2"><strong className="mr-2">VALOR TOTAL:</strong> {formatarParaMoedaBRL(parseValor(creditoScore.PEND_FINANCEIRAS.VALOR_TOTAL))}</div>
                        </div>
                        <div className="col-12 md:col-6">
                          <div className="mb-2 text-right"><strong className="mr-2">ÚLTIMO VENCIMENTO:</strong> {ultimoVencimento}</div>
                        </div>
                      </div>
                    </div>

                    {/* Table Section */}
                    <div className="surface-100 border-round">
                      <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">PENDÊNCIAS <i className="pi pi-arrow-right text-sm mx-2"></i> BASE I</div>
                      <DataTable size="small" value={ocorrencias} tableStyle={{ minWidth: '50rem' }} emptyMessage="Nenhuma pendência encontrada.">
                        <Column field="DATA_VENCIMENTO" header="VENCIMENTO"></Column>
                        <Column field="CONTRATO" header="CONTRATO"></Column>
                        <Column field="VALOR" header="VALOR" body={(rowData) => {
                          const val = parseValor(rowData.VALOR);
                          return formatarParaMoedaBRL(val);
                        }}></Column>
                        <Column field="TIPO_DEVEDOR" header="TIPO"></Column>
                        <Column field="CREDOR" header="CREDOR"></Column>
                        <Column field="INFORMANTE" header="BASE" ></Column>
                      </DataTable>
                    </div>
                  </div>
                );
              })()
            )}
          </Panel>}
          <br></br>

          {creditoScore.PEND_REFIN && (
            <Panel headerTemplate={headerTemplatePendRefin}>
              {!creditoScore.PEND_REFIN.OCORRENCIAS || creditoScore.PEND_REFIN.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (
                (() => {
                  const ocorrencias = creditoScore.PEND_REFIN.OCORRENCIAS;
                  const parseValor = (v: any) => {
                    if (typeof v === 'number') return v;
                    if (typeof v === 'string') {
                      const clean = v.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
                      return parseFloat(clean) || 0;
                    }
                    return 0;
                  };
                  const sortedByDate = [...ocorrencias].sort((a: any, b: any) => {
                    const dateA = a.DATA_VENCIMENTO ? a.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                    const dateB = b.DATA_VENCIMENTO ? b.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                    return dateB.localeCompare(dateA);
                  });
                  const ultimoVencimento = sortedByDate[0]?.DATA_VENCIMENTO || '-';

                  return (
                    <div className="flex flex-column gap-4">
                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">RESUMO</div>
                        <div className="grid p-3">
                          <div className="col-12 md:col-6">
                            <div className="mb-2"><strong className="mr-2">QUANTIDADE:</strong> {creditoScore.PEND_REFIN.QUANTIDADE_OCORRENCIA}</div>
                            <div className="mb-2"><strong className="mr-2">VALOR TOTAL:</strong> {formatarParaMoedaBRL(parseValor(creditoScore.PEND_REFIN.VALOR_TOTAL))}</div>
                          </div>
                          <div className="col-12 md:col-6">
                            <div className="mb-2 text-right"><strong className="mr-2">ÚLTIMO VENCIMENTO:</strong> {ultimoVencimento}</div>
                          </div>
                        </div>
                      </div>

                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">PENDÊNCIAS <i className="pi pi-arrow-right text-sm mx-2"></i> BASE I</div>
                        <DataTable size="small" value={ocorrencias} tableStyle={{ minWidth: '50rem' }} emptyMessage="Nenhuma pendência encontrada.">
                          <Column field="DATA_VENCIMENTO" header="VENCIMENTO"></Column>
                          <Column field="CONTRATO" header="CONTRATO"></Column>
                          <Column field="VALOR" header="VALOR" body={(rowData) => formatarParaMoedaBRL(parseValor(rowData.VALOR))}></Column>
                          <Column field="TIPO_DEVEDOR" header="TIPO"></Column>
                          <Column field="CREDOR" header="CREDOR"></Column>
                          <Column field="INFORMANTE" header="BASE" style={{ whiteSpace: 'nowrap' }}></Column>
                        </DataTable>
                      </div>
                    </div>
                  );
                })()
              )}
            </Panel>
          )}
          <br></br>

          {creditoScore.PEND_VENCIDAS && (
            <Panel headerTemplate={headerTemplatePendVencidas}>
              {!creditoScore.PEND_VENCIDAS.OCORRENCIAS || creditoScore.PEND_VENCIDAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (
                (() => {
                  const ocorrencias = creditoScore.PEND_VENCIDAS.OCORRENCIAS;
                  const parseValor = (v: any) => {
                    if (typeof v === 'number') return v;
                    if (typeof v === 'string') {
                      const clean = v.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
                      return parseFloat(clean) || 0;
                    }
                    return 0;
                  };
                  const sortedByDate = [...ocorrencias].sort((a: any, b: any) => {
                    const dateA = a.DATA_VENCIMENTO ? a.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                    const dateB = b.DATA_VENCIMENTO ? b.DATA_VENCIMENTO.split('/').reverse().join('-') : '';
                    return dateB.localeCompare(dateA);
                  });
                  const ultimoVencimento = sortedByDate[0]?.DATA_VENCIMENTO || '-';

                  return (
                    <div className="flex flex-column gap-4">
                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">RESUMO</div>
                        <div className="grid p-3">
                          <div className="col-12 md:col-6">
                            <div className="mb-2"><strong className="mr-2">QUANTIDADE:</strong> {creditoScore.PEND_VENCIDAS.QUANTIDADE_OCORRENCIA}</div>
                            <div className="mb-2"><strong className="mr-2">VALOR TOTAL:</strong> {formatarParaMoedaBRL(parseValor(creditoScore.PEND_VENCIDAS.VALOR_TOTAL))}</div>
                          </div>
                          <div className="col-12 md:col-6">
                            <div className="mb-2 text-right"><strong className="mr-2">ÚLTIMO VENCIMENTO:</strong> {ultimoVencimento}</div>
                          </div>
                        </div>
                      </div>

                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">PENDÊNCIAS <i className="pi pi-arrow-right text-sm mx-2"></i> BASE I</div>
                        <DataTable size="small" value={ocorrencias} tableStyle={{ minWidth: '50rem' }} emptyMessage="Nenhuma pendência encontrada.">
                          <Column field="DATA_VENCIMENTO" header="VENCIMENTO"></Column>
                          <Column field="CONTRATO" header="CONTRATO"></Column>
                          <Column field="VALOR" header="VALOR" body={(rowData) => formatarParaMoedaBRL(parseValor(rowData.VALOR))}></Column>
                          <Column field="TIPO_DEVEDOR" header="TIPO"></Column>
                          <Column field="CREDOR" header="CREDOR"></Column>
                          <Column field="INFORMANTE" header="BASE"></Column>
                        </DataTable>
                      </div>
                    </div>
                  );
                })()
              )}
            </Panel>
          )}
          <br></br>

          {creditoScore.PROTESTOS && (
            <Panel headerTemplate={headerTemplateProtestosNew}>
              {!creditoScore.PROTESTOS.OCORRENCIAS || creditoScore.PROTESTOS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (
                (() => {
                  const ocorrencias = creditoScore.PROTESTOS.OCORRENCIAS;
                  const parseValor = (v: any) => {
                    if (typeof v === 'number') return v;
                    if (typeof v === 'string') {
                      const clean = v.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
                      return parseFloat(clean) || 0;
                    }
                    return 0;
                  };
                  const sortedByDate = [...ocorrencias].sort((a: any, b: any) => {
                    const dateA = a.DATA ? a.DATA.split('/').reverse().join('-') : '';
                    const dateB = b.DATA ? b.DATA.split('/').reverse().join('-') : '';
                    return dateA.localeCompare(dateB);
                  });
                  const primeiroVencimento = sortedByDate[0]?.DATA || '-';

                  return (
                    <div className="flex flex-column gap-4">
                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">RESUMO</div>
                        <div className="grid p-3">
                          <div className="col-12 md:col-6">
                            <div className="mb-2"><strong className="mr-2">QUANTIDADE:</strong> {creditoScore.PROTESTOS.QUANTIDADE_OCORRENCIA}</div>
                            <div className="mb-2"><strong className="mr-2">VALOR TOTAL:</strong> {formatarParaMoedaBRL(parseValor(creditoScore.PROTESTOS.VALOR_TOTAL))}</div>
                          </div>
                          <div className="col-12 md:col-6">
                            <div className="mb-2 text-right"><strong className="mr-2">PRIMEIRO:</strong> {primeiroVencimento}</div>
                          </div>
                        </div>
                      </div>

                      <div className="surface-100 border-round">
                        <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">OCORRÊNCIAS</div>
                        <DataTable size="small" value={ocorrencias} tableStyle={{ minWidth: '50rem' }} emptyMessage="Nenhum protesto encontrado.">
                          <Column field="DATA" header="DATA"></Column>
                          <Column field="VALOR" header="VALOR" body={(rowData) => formatarParaMoedaBRL(parseValor(rowData.VALOR))}></Column>
                          <Column field="CREDOR" header="CREDOR"></Column>
                          <Column field="CARTORIO" header="CARTÓRIO"></Column>
                          <Column header="QTD" body={() => "1"}></Column>
                          <Column field="ORIGEM" header="ORIGEM" style={{ whiteSpace: 'nowrap' }}></Column>
                          <Column field="TIPO_ANOTACAO" header="TIPO ANOTAÇÃO" body={(rowData) => rowData.TIPO_ANOTACAO || 'NAO DIVULGADO'} style={{ whiteSpace: 'nowrap' }}></Column>
                        </DataTable>
                      </div>
                    </div>
                  );
                })()
              )}
            </Panel>
          )}

          <br></br>

          {creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && (
            <Panel headerTemplate={headerTemplateProtesto}>
              {creditoScore.dados?.protesto.registro.length === 0 ? (<NadaConsta />) : (<>
                <div className="flex-consulta  flex-wrap gap-3">
                  {getResumoProtesto().map((item: any, index: number) => (

                    <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                      <div className="flex-consulta  justify-content-between gap-5">
                        <div className="flex-consulta  flex-column gap-1">
                          <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                          <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                        </div>
                        <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                          <i className={item.icon} />
                        </span>
                      </div>
                    </Card>

                  ))}
                </div>
                <br></br>
                <DataTable size="small" value={creditoScore.PROTESTO_SINTETICO.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="DATA_OCORRENCIA" header={t('data')}></Column>
                  <Column field="CARTORIO" header={t('cartorio')}></Column>
                  <Column field="COMARCA" header={t('cidade')}></Column>
                  <Column field="UF" header={t('uf')}></Column>
                  <Column field="VALOR" header={t('valor')}></Column>
                </DataTable>
              </>)}
            </Panel>)}
          <br></br>

          {creditoScore.CH_SEM_FUNDOS_BACEN && (
            <Panel headerTemplate={headerTemplateCheques}>
              {!creditoScore.CH_SEM_FUNDOS_BACEN.OCORRENCIAS || creditoScore.CH_SEM_FUNDOS_BACEN.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
                <DataTable size="small" value={creditoScore.CH_SEM_FUNDOS_BACEN.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="DATA_EMISSAO" header={t('data')}></Column>
                  <Column field="BANCO" header={t('banco')}></Column>
                  <Column field="AGENCIA" header={t('agencia')}></Column>
                  <Column field="CONTA" header="Conta"></Column>
                  <Column field="CHEQUE" header="Cheque"></Column>
                  <Column field="VALOR" header={t('valor')}></Column>
                </DataTable>
              </>)}
            </Panel>
          )}

          <br></br>

          {creditoScore.PARTICIPACAO_EM_EMPRESAS && (
            <Panel headerTemplate={headerTemplateParticipacaoEmpresas}>
              {!creditoScore.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS || creditoScore.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
                <DataTable size="small" value={creditoScore.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="CNPJ" header="CNPJ" body={(rowData) => formatarCNPJ(rowData.CNPJ)}></Column>
                  <Column field="RAZAO_SOCIAL" header="Razão Social"></Column>
                  <Column field="PARTICIPACAO" header="Participação" body={(rowData) => rowData.PARTICIPACAO ? `${rowData.PARTICIPACAO}%` : ''}></Column>
                  <Column field="PARTICIPANTE_ENTRADA" header="Data de Entrada"></Column>
                  <Column field="PARTICIPANTE_CARGO" header="Cargo"></Column>
                  <Column field="PARTICIPANTE_TIPO" header="Tipo"></Column>
                  <Column field="QTD_OUTROS_SOCIOS" header="Outros Sócios"></Column>
                </DataTable>
              </>)}
            </Panel>
          )}
          {creditoScore.PASSAGENS_COMERCIAIS && (
            <Panel headerTemplate={headerTemplatePassagens}>
              {!creditoScore.PASSAGENS_COMERCIAIS.OCORRENCIAS || creditoScore.PASSAGENS_COMERCIAIS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
                <DataTable size="small" value={creditoScore.PASSAGENS_COMERCIAIS.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="DATA_CONSULTA" header="DATA"></Column>
                  <Column field="CLIENTE_CONSULTA" header="EMPRESA"></Column>
                  <Column field="CIDADE_UF_CLIENTE" header="ORIGEM"></Column>
                </DataTable>
              </>)}
            </Panel>
          )}
          <br></br>
        </div>)}
    </div>
  )
}